import React, {useEffect, useState} from 'react';
import style from './headerMatch.module.css';
import HeaderMenu from '../headerMenu/headerMenu';
import Breadcrumbs from '../breadcrumbs/breadcrumbs';
import {Match} from "../../types/matchTypes";

interface Score {
	home: number;
	away: number;
}
interface ScoreEvent {
	type: 'goal' | 'owngoal' | 'penalty kick' | 'penalty shoot-out goal';
	team: 'home' | 'away';
	time: number | string;
	playerName: string;
	icon: string;
}
interface HeaderMatchProps {
	match: Match | null;
	score: Score;
	scoreEvents: ScoreEvent[];
	penalties: Score;
}
interface Tournament {
	id: number;
	name: string;
	type: string;
	season: string;
}

const HeaderMatch: React.FC<HeaderMatchProps> = ({ match, score, scoreEvents, penalties}) => {
	const [tournamentData, setTournamentData] = useState<Tournament[]>([]);
	const formatTime = (dateString: string | null) => {
		if (!dateString) return 'N/A'
		const date = new Date(dateString)
		return date.toLocaleTimeString('en-US', {
			hour: '2-digit',
			minute: '2-digit',
			weekday: 'short',
			month: 'long',
			day: 'numeric'
		})
	}
	const formatTimezone = (dateString: string | null) => {
		if (!dateString) return 'N/A'
		const date = new Date(dateString)
		return date
			.toLocaleTimeString('en-US', {
				timeZoneName: 'short',
			})
			.split(' ')
			.pop()
	}

	const formattedTime = match?.actual_start_time ? formatTime(match.actual_start_time) : '';
	const formattedTimezone = match?.actual_start_time ? formatTimezone(match.actual_start_time) : '';

	return (
		<header className={style.header}>
			<div className={style.header__content}>
				<Breadcrumbs />
				<div className={style.match_data__container}>
					<div className={style.match__tournament_data}>
						<p>{match?.tournament_short_name}</p>
						<p className={style.text_secondary}>{match?.tournament_season}, {match?.round_name}</p>
					</div>
					<div className={style.match__date_data}>
						<p className={style.match__date_time}>{formattedTime.toUpperCase()}</p>
						<p className={style.text_secondary}>{formattedTimezone}</p>
					</div>
					<div className={style.match__tournament_data_mobile}>
						<p className={style.text_secondary}>{match?.tournament_short_name}</p>
						<p className={style.text_secondary}>{match?.tournament_season}, {match?.round_name}</p>
					</div>
					<div className={style.match__stadium_data}>
						<p>{match?.stadium_name}</p>
						<p className={style.text_secondary}>{match?.stadium_country}, {match?.stadium_city}</p>
					</div>
				</div>
				<div className={style.match_teams_score}>
					<div className={style.match_team}>
						<div className={style.match_team__logo}>
							<img className={style.match_team__logo_img} src={match?.host_club_logo} />
						</div>
						<p className={style.match_team__name}>{match?.host_team_name}</p>
						<p className={style.match_team__city}>{match?.host_city_name}</p>
						<ul className={style.recentResults}>
							<li></li>
							<li></li>
							<li></li>
							<li></li>
							<li></li>
						</ul>
					</div>
					<div className={style.match_score__container}>
						<div className={style.match_score}>
							<span className={style.match_score__number}>{score.home}</span>
							<span>–</span>
							<span className={style.match_score__number}>{score.away}</span>
						</div>
						{ penalties.home+penalties.away > 1 &&
							<div className={style.penalties_score}>
								({penalties.home} – {penalties.away})
							</div>
						}
						<div className={style.match_status}>{match?.status}</div>
						<div className={style.scoreEvents}>
							<div className={style.homeTeamEvents}>
								{scoreEvents
									.filter(event => event.team === 'home')
									.map((event, index) => (
										<div key={`home-${index}`} className={style.eventItem}>
											<span className={style.eventPlayer}>{event.playerName}</span>
											<span className={style.eventTime}>{event.time}'</span>
											<span className={style.eventType}>
											<img
												src={event.icon || ''}
												alt={event.icon  || ''}
											/>
          </span>
										</div>
									))}
							</div>
							<div className={style.awayTeamEvents}>
								{scoreEvents
									.filter(event => event.team === 'away')
									.map((event, index) => (
										<div key={`away-${index}`} className={style.eventItem}>
          <span className={style.eventType}>
											<img
												src={event.icon || ''}
												alt={event.icon  || ''}
											/>
          </span>
											<span className={style.eventTime}>{event.time}'</span>
											<span className={style.eventPlayer}>{event.playerName}</span>
										</div>
									))}
							</div>
						</div>
					</div>

					<div className={style.match_team}>
						<div className={style.match_team__logo}>
							<img className={style.match_team__logo_img} src={match?.guest_club_logo} />
						</div>
						<p className={style.match_team__name}>{match?.guest_team_name}</p>
						<p className={style.match_team__city}>{match?.guest_city_name}</p>
						<ul className={style.recentResults}>
							<li></li>
							<li></li>
							<li></li>
							<li></li>
							<li></li>
						</ul>
					</div>
				</div>
				<div className={style.match_status_mobile}>
					{match?.status}
				</div>
				<div className={style.scoreEvents_mobile}>
					<div className={style.homeTeamEvents}>
							{scoreEvents
								.filter(event => event.team === 'home')
								.map((event, index) => (
									<div key={`home-${index}`} className={style.eventItem}>
										<span className={style.eventPlayer}>{event.playerName}</span>
										<span className={style.eventTime}>{event.time}'</span>
										<span className={style.eventType}>
											<img
												src={event.icon || ''}
												alt={event.icon  || ''}
											/>
          </span>
									</div>
								))}
						</div>
					<div className={style.awayTeamEvents}>
							{scoreEvents
								.filter(event => event.team === 'away')
								.map((event, index) => (
									<div key={`away-${index}`} className={style.eventItem}>
          <span className={style.eventType}>
											<img
												src={event.icon || ''}
												alt={event.icon  || ''}
											/>
          </span>
										<span className={style.eventTime}>{event.time}'</span>
										<span className={style.eventPlayer}>{event.playerName}</span>
									</div>
								))}
						</div>
				</div>
				<HeaderMenu />
			</div>
		</header>
	);
};

export default HeaderMatch;
